import type { Client2TrackedTranslation } from '@ps/web-core-intl';
import { isArray } from 'lodash';
import type React from 'react';

import Translation from '../../Translation/Translation';
import { isTranslation } from '../../locales/locales';
import type { trackingTranslation } from '../../locales/locales';

export type LabelProp = Parameters<typeof trackingTranslation>['0'];

export const useDisplayLabel = (label: LabelProp): React.ReactNode => {
  if (isArray(label)) {
    return (
      <>
        {label.reduce((memo: React.ReactNode[], props: Client2TrackedTranslation, index) => {
          memo.push(<Translation key={props.id} {...props} />);
          if (index < label.length - 1) memo.push(' ');
          return memo;
        }, [])}
      </>
    );
  }

  if (isTranslation(label)) {
    return <Translation {...label} />;
  }

  return label;
};

export default useDisplayLabel;
